/* unplugin-vue-components disabled */import __unplugin_components_0 from '/home/pedrazzi/projetos/advogados/v5/src/components/Alert/Index.vue';
var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-app",
    [
      _c("layout-navigation", { attrs: { theme: _vm.theme } }),
      _vm._v(" "),
      _c("v-main", { staticClass: "mb-4" }, [_vm._t("default")], 2),
      _vm._v(" "),
      _c("layout-footer", { attrs: { theme: _vm.theme } }),
      _vm._v(" "),
      _c(__unplugin_components_0),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }